import React, { Fragment, useContext } from "react";
import { Container, Nav, Spinner, Tab } from "react-bootstrap";
import { useQuery } from "react-query";
import { FetchEventsData } from "../api";
import Preloader from "../components/loader/Preloader";
import Footer from "../components/Main/Footer";
import Header from "../components/Main/Header";
import Card from "../components/Sustainathons/Card";
import { EventSus } from "../data/Lists";
import { Helmet } from "react-helmet";
import { LanguageContext } from "../App";
import TEXT from "../data/text";

const AllEvents = ({ events, type }) => {
  const { language, languages } = useContext(LanguageContext);
  return (
    <section id="events">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="section-title">
              {type === "upcoming" ? (
                <h1>{TEXT[language]["EVENTS"]["0"]}</h1>
              ) : type === "ongoing" ? (
                <h1>{TEXT[language]["EVENTS"]["1"]}</h1>
              ) : (
                <h1>{TEXT[language]["EVENTS"]["2"]}</h1>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="tab-content-wrap row">
              {events && events.length > 0 ? (
                events &&
                events.map((eachEvent, key) => {
                  const Webinar =
                    eachEvent?.translation?.[languages[language]] || eachEvent;
                  const extraLanguages = Object.keys(
                    eachEvent?.translation || {}
                  ).map((each) => each.toUpperCase());
                  return (
                    <Card
                      key={Webinar.id}
                      id={Webinar.id}
                      Title={Webinar.title}
                      Desc={Webinar.Desc}
                      location={Webinar.location}
                      By={Webinar.By}
                      SDate={Webinar.startFDate}
                      EDate={Webinar.endFDate}
                      Image={Webinar.imageUrl}
                      organizer={Webinar.organizer}
                      status={Webinar.status}
                      extraLanguages={extraLanguages}
                    />
                  );
                })
              ) : (
                <div
                  className="container"
                  style={{
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                  }}
                >
                  {type === "ongoing" ? (
                    <h4>{TEXT[language]["EVENTS"]["3"]}</h4>
                  ) : type === "upcoming" ? (
                    <h4>{TEXT[language]["EVENTS"]["4"]}</h4>
                  ) : type === "archive" ? (
                    <h4>{TEXT[language]["EVENTS"]["5"]}</h4>
                  ) : (
                    <h4>{TEXT[language]["EVENTS"]["6"]}</h4>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
const Events = () => {
  const { language } = useContext(LanguageContext);
  const results = useQuery(
    // result  contains main bottom bg banner image
    {
      queryKey: ["events"],
      queryFn: () => FetchEventsData(),
      staleTime: 10000,
      refetchOnWindowFocus: false,
    }
  );

  if (results.isLoading) {
    return (
      <Fragment>
        <Helmet>
          <title>{TEXT[language]["EVENTS"]["9"]}</title>
        </Helmet>
        <Preloader />
      </Fragment>
    );
  } else if (results.isError || results.data === "no data") {
    return (
      <Fragment>
        <Helmet>
          <title>{TEXT[language]["EVENTS"]["8"]}</title>
        </Helmet>
        <Errorpage />
      </Fragment>
    );
  } else if (results.data) {
    return (
      <Fragment>
        <Helmet>
          <title>{TEXT[language]["EVENTS"]["7"]}</title>
        </Helmet>
        <div id="events" style={{ background: "#F6F9F9" }}>
          <Header
            obj={EventSus[language]}
            bgbanner={process.env.REACT_APP_EVENTS_TOP_BG}
          />
          {results.isSuccess ? (
            <main>
              <Container
                fluid
                className="mb-3"
                style={{ background: "#F6F9F9" }}
              >
                <Tab.Container
                  id="left-tabs-example"
                  defaultActiveKey="ongoing"
                >
                  <Container>
                    <Nav className="event-tabs" variant="pills">
                      <Nav.Item>
                        <Nav.Link eventKey="ongoing">
                          {TEXT[language]["EVENTS"]["10"]}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="upcoming">
                          {TEXT[language]["EVENTS"]["11"]}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="archive">
                          {TEXT[language]["EVENTS"]["12"]}
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Container>
                  <Tab.Content>
                    <Tab.Pane eventKey="ongoing">
                      <AllEvents
                        events={results.data.ongoing}
                        loading={results.data.isLoading}
                        type="ongoing"
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="upcoming">
                      <AllEvents
                        events={results.data.upcoming}
                        loading={results.data.isLoading}
                        type="upcoming"
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="archive">
                      <AllEvents
                        events={results.data.archive}
                        loading={results.data.isLoading}
                        type="archive"
                      />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Container>
            </main>
          ) : (
            <Loader />
          )}

          <Footer />
        </div>
      </Fragment>
    );
  }
};

export default Events;

const Loader = () => {
  // const { language } = useContext(LanguageContext);

  return (
    <Container fluid className="text-center padding">
      <Spinner
        className="load-spinner"
        style={{ width: "2rem", height: "2rem" }}
        animation="border"
        role="status"
      >
        <span className="sr-only">{TEXT[language]["EVENTS"]["13"]}</span>
      </Spinner>
    </Container>
  );
};
